// Central place for brand assets (logo + hero photography) so we only reference them
// through one module across the app.

export const BRAND = {
  name: "Bharti Energy Point",
  tagline: "Fuelling Journeys · Powering Futures",
  outlet: "BPCL Retail Outlet",
  // Full-color primary logo (transparent-friendly PNG)
  logo:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_nozzle-dashboard/artifacts/ww2ral3o_C1872262-945C-4860-8CFC-3B10DAEEF692.png",
  // Photos of the actual outlet, night shots
  pumpHero:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_nozzle-dashboard/artifacts/fttdbavf_CEC88DAB-DB63-42C7-A624-0D0FBBEDF27E.webp",
  pumpSide:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_nozzle-dashboard/artifacts/je2mh0wr_IMG_3660.webp",
};

export default BRAND;
